import React from 'react';
import { userService } from '../_services';
import loginbg from '../../src/components/css/dark/img/bg.png';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import loader from '../../src/components/css/dark/img/loader.gif';
import RphLogo from '../../src/components/css/dark/img/rph-logo.png';
import $ from 'jquery';

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            error: '',
            islogginchecked: false,
            switchLogo: false
        };
        if (localStorage.getItem('user') != null && localStorage.getItem('user') != "" && localStorage.getItem('user') != "null" && localStorage.getItem('user') != "{}") {
            var User_Post = JSON.parse(localStorage.getItem('user'));
            //userService.logout();
            userService.getUser(User_Post["id"], User_Post["authdata"])
                .then(
                    user => {
                        if (user != "") {
                            const { from } = this.props.location.state || { from: { pathname: "/" } };
                            this.props.history.push(from);

                        }
                        else {

                        }
                        this.state.islogginchecked = true;
                    },
                    error => this.setState({ error, loading: false })
                );
        }
        else {
            this.state.islogginchecked = true;
            userService.logout();
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = 'Login Page';
        try {
            let params = new URL(window.location.href).searchParams;
            if (params.get('q') != null && params.get('q') != undefined && params.get('q') != "")
                this.Login_RXH(params.get('q'));
            if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
                $('body').addClass('rx-user');
                console.log("Testing caching")
            }
        }
        catch (error) { }
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        $('.username').removeClass('errorIcon');
        $('.password').removeClass('errorIcon');

        this.setState({ submitted: true });
        const { username, password, returnUrl } = this.state;

        // stop here if form is invalid
        let IsErrorExists = false;
        if (!(username)) {
            $('.username').addClass('errorIcon');
            IsErrorExists = true;
        }
        if (!(password)) {
            $('.password').addClass('errorIcon');
            IsErrorExists = true;
        }
        if (IsErrorExists == true) {
            return;
        }
        this.setState({ loading: true });
        userService.login(username, password)
            .then(
                user => {
                    if (user.length > 0 && (user[0].userName != null || user[0].userEmail != null)) {
                        const { from } = this.props.location.state || { from: { pathname: "/" } };
                        window.xl();
                        window.InitializeHubspotChat();
                        window.x();

                        this.props.history.push(from);
                        //window.location.href = window.location.origin;
                    }
                    else if (user.length == 0 || user == "" || user.length == undefined || user.length =="{}")
                    {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: 'Incorrect Username or Password.', loading: false });
                    }
                    else if (user[0].userId.indexOf('A network-related or instance-specific error occurred while establishing a connection to SQL Server') > -1) {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: 'Whoops, something went wrong. Please try again.', loading: false });
                    }
                    else if (user[0].userId.indexOf('Access to this dashboard has been terminated') > -1) {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: user[0].userId, loading: false });
                    }
                    else {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: 'Incorrect Username or Password.', loading: false });
                    }

                },
                error => {
                    try {
                        userService.logout();
                        this.setState({ error, loading: false });
                    }
                    catch (error) { }
                }
            );
    }
    Login_RXH(quid) {
        userService.loginrxh(window.atob(quid))
            .then(
                user => {
                    if (user.length > 0 && (user[0].userName != null || user[0].userEmail != null)) {
                        const { from } = this.props.location.state || { from: { pathname: "/" } };
                        window.xl();
                        window.InitializeHubspotChat();
                        window.x();
                        this.props.history.push(from);
                    }
                    else if (user[0].userId.indexOf('A network-related or instance-specific error occurred while establishing a connection to SQL Server') > -1) {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: 'Whoops, something went wrong. Please try again.', loading: false });
                    }
                    else if (user[0].userId.indexOf('User not available at dashboard end') > -1) {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: user[0].userId, loading: false });
                    }
                    else {
                        userService.logout();
                        this.setState({ loading: false });
                        this.setState({ error: 'Incorrect Username or Password.', loading: false });
                    }
                },
                error => {
                    try {
                        userService.logout();
                        this.setState({ error, loading: false });
                    }
                    catch (error) { }
                }
            );
    }
    openModal = () => {
        try {
            var winURL = '';
            if (window.location.host == "dev.glichealth.com" || window.location.origin.includes('localhost:') || window.location.host == "release.glichealth.com")
                winURL = 'https://dev-backoffice.rxhacker.com/login';
            else if (window.location.host == "staging.glichealth.com" || window.location.host == "reporting.rxhacker.com")
                winURL = 'https://backoffice.rxhacker.com/login';
            var child = window.open(winURL, 'popup', 'width=600,height=600,scrollbars=no,resizable=no');
            var timer = setInterval(checkChild, 500);
            function checkChild() {
                if (child.closed)
                    clearInterval(timer);
            }
        }
        catch (error) { }
    }

    render() {
        const { username, password, submitted, loading, error } = this.state;
        let logoUrl = '';
        if (window.location.host.toLowerCase() == "reporting.patientrxdiscount.com") {
            logoUrl = '/Patient-Rx-Discount.svg';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            logoUrl = '/Rxhacker_logo_new.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "glichealth.com") {
            logoUrl = '/GlicHealth_logo.png';
        } else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "honestdiscounts.com") {
            logoUrl = '/hdrx-logo.svg';
        } else {
            logoUrl = '/GlicHealth_logo.png';
        }

        if (this.state.islogginchecked) {
            return (
                <div>
                    <div className="main">
                        <div className="left-one">
                            <div className="content">
                                <div className="adjust-content">
                                    <img className="honest-logo" src={window.location.origin + logoUrl} crossorigin="anonymous" alt="logo" />
                                    <div className="col-md-6 col-md-offset-3">
                                        <form name="form" onSubmit={this.handleSubmit}>
                                            <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                                                <input type="text" className={error.length > 0 ? 'form-control userwidth username errorIcon' : 'form-control userwidth username'} name="username" placeholder='you@example.com' value={username} onChange={this.handleChange} />
                                                {submitted && !username &&
                                                    <div className="help-block">Username is required</div>
                                                }
                                            </div>
                                            <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                                <input type="password" className={error.length > 0 ? 'form-control password userwidth errorIcon' : 'form-control password userwidth'} name="password" placeholder='Enter 6 character or more' value={password} onChange={this.handleChange} />
                                                {submitted && !password &&
                                                    <div className="help-block">Password is required</div>
                                                }
                                            </div>
                                            {error &&
                                                <div className={'help-block'}>{error}</div>
                                            }
                                            <div className="form-group check">

                                                <NavLink to="/resetPassword" activeClassName="active" className="forget">Forgot Password?</NavLink>
                                                <input type="checkbox" id="checkbox" className="form-control checkBox" />
                                                <label htmlFor="checkbox"><span>Remember me</span></label>
                                            </div>
                                            <div className="form-group">
                                                <button className="signInButton btn" disabled={loading}>Sign in</button>

                                                {loading &&

                                                    <div className="load-container"><div className="theme-loader"></div></div>
                                                }
                                            </div>
                                        </form>
                                        {/*{
                                            window.location.origin.includes("https://staging.glichealth.com") || window.location.origin.includes("https://reporting.rxhacker.com") || window.location.origin.includes('//localhost:') || window.location.origin.includes('dev.glichealth.com') || window.location.origin.includes('release.glichealth.com')?
                                                <button className="signInButton btn backOffice" onClick={this.openModal} disabled={loading}><img className="rphLogo" src={RphLogo} alt="logo" />Sign In with RXH Backoffice</button>:null
                                        }*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            );
        }
        else {
            return (
                <div>
                    <img className="loader" src={loader} alt="loader" />                                            }
                </div>
            );
        }
    }
}

export { LoginPage }; 